module.exports = __webpack_public_path__ + "static/media/8-audio.3caeec2.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/8-audio.wav
// module id = VbZf
// module chunks = 0